import { render } from "./TutoJeu.vue?vue&type=template&id=59d72aea&scoped=true"
import script from "./TutoJeu.vue?vue&type=script&lang=js"
export * from "./TutoJeu.vue?vue&type=script&lang=js"

import "./TutoJeu.vue?vue&type=style&index=0&id=59d72aea&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d72aea"]])

export default __exports__